import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';

import {
    ActionsColumn,
    CallResultColumn,
    CampaignColumn,
    DurationColumn,
    IdColumn,
    NumberColumn,
    SegmentsColumn,
} from './columns';
import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import { DateTimeColumn, MultiSelectCreatable } from '../../../common';
import {
    getChatScripts,
    getDatasets,
    getMessageGroups,
    getVoiceCalls,
} from '../../../../http/apiClient';
import {
    useDebouncedCallback,
    useDisclosure,
    useLocalStorage,
} from '@mantine/hooks';
import { useMemo, useState } from 'react';

import CallTranscriptModal from '../../../modals/engagement/CallTranscriptModal';
import FiltersMultiSelect from '../../../common/filtersMultiSelect/FiltersMultiSelect';
import { MantineReactTable } from 'mantine-react-table';
import { usePaginatedQuery } from '../../../../http/queries/usePaginatedQuery';

const CallListView = ({ ...props }) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 20,
    });

    const [
        transcriptModalOpen,
        { open: openTranscriptModal, close: closeTranscriptModal },
    ] = useDisclosure();

    const [modalTranscript, setModalTranscript] = useState(null);

    const filterDebounce = useDebouncedCallback((query) => {
        setGlobalFilter(query);
    }, 600);

    const {
        isLoading,
        isError,
        error,
        data: paginatedData,
    } = usePaginatedQuery({
        queryFn: (queryParams) => getVoiceCalls(queryParams),
        queryKey: ['voice_calls'],
        refetchInterval: 15_0000,
        globalFilter,
        pagination,
        sorting,
    });

    const { data: voicecalls, pagination: dataPagination } =
        paginatedData || {};

    const handleOpenTranscript = (rowData) => {
        setModalTranscript(rowData.transcript);
        openTranscriptModal();
    };

    const columns = useMemo(
        () => [
            IdColumn(),
            CampaignColumn(),
            NumberColumn(),
            CallResultColumn(),
            DurationColumn(),
            SegmentsColumn({ openModal: handleOpenTranscript }),
            DateTimeColumn({
                id: 'at',
                header: 'At',
                accessorFn: (rowData) => rowData.at,
                format: 'L LTS',
            }),
        ],
        [voicecalls]
    );

    /*const tableData = useMemo(
        () => (isLoading ? [] : campaigns),
        [campaigns, isLoading]
    );*/

    const tableData = useMemo(
        () => (isLoading ? [] : voicecalls),
        [voicecalls, isLoading]
    );

    const [columnVisibility, setColumnVisibility] = useLocalStorage({
        key: 'voicecalls-table-visibility', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const [columnSizing, setColumnSizing] = useLocalStorage({
        key: 'voicecalls-group-table-sizing', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const handleVisibilityChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnVisibility((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handlSizeChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnSizing((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handleFilterChange = (queryStr) => {
        filterDebounce(queryStr);
    };

    const tableProps = {
        columns: columns,
        data: tableData,
        enableRowActions: false,
        enableColumnResizing: true,
        enableColumnActions: false,
        enableSorting: false,
        enableTopToolbar: true,
        enableGlobalFilter: true,
        enableFilters: false,
        enableStickyHeader: true,
        enableDensityToggle: false,
        positionActionsColumn: 'last',
        layoutMode: 'semantic',
        mantineSearchTextInputProps: {
            placeholder: 'Search Calls',
            miw: 200,
        },
        mantineTableContainerProps: {
            style: {
                minHeight: '80vh',
            },
        },
        positionGlobalFilter: 'left',
        renderTopToolbarCustomActions: () => (
            <Box
                w={'100%'}
                px={'lg'}>
                <FiltersMultiSelect
                    options={[{ label: 'test', value: 'test' }]}
                />
            </Box>
        ),
        //renderRowActions: ActionsColumn,

        manualPagination: true,
        manualSorting: true,
        onColumnVisibilityChange: handleVisibilityChange,
        onColumnSizingChange: handlSizeChange,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onGlobalFilterChange: handleFilterChange,
        rowCount: dataPagination?.totalItems || 0,
        pageCount: dataPagination?.totalPages || 1,

        initialState: {
            columnVisibility,
            pagination,
            isLoading,
            showGlobalFilter: true,
        },
        state: {
            isLoading,
            pagination,
            columnVisibility,
            columnSizing,
            showAlertBanner: isError,
            showProgressBars: isLoading,
            sorting,
            density: 'xs',
        },
    };

    return (
        <Container fluid>
            <MantineReactTable {...tableProps} />
            <CallTranscriptModal
                transcript={modalTranscript}
                opened={transcriptModalOpen}
                close={closeTranscriptModal}
            />
        </Container>
    );
};
export default CallListView;
